import { useEffect } from "react";
import { useNavigate } from "react-router";
import { CheckCircle } from "lucide-react";

import PageWrapper from "@/components/layout/page-wrapper";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const PaymentSuccess = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Auto redirect to dashboard after 5 seconds
        const timer = setTimeout(() => {
            navigate("/app/dashboard");
        }, 5000);

        return () => clearTimeout(timer);
    }, [navigate]);

    const handleNavigate = () => {
        navigate("/app/dashboard");
    };

    return (
        <PageWrapper pageTitle="Payment Successful" currentPage="Payment Success">
            <div className="flex flex-col items-center justify-center h-full py-12">
                <Card className="bg-white p-8 max-w-md w-full mx-4 shadow-lg">
                    <div className="flex flex-col items-center justify-center">
                        <div className="bg-green-100 rounded-full p-4 mb-6">
                            <CheckCircle className="h-16 w-16 text-green-600" />
                        </div>
                        <h1 className="text-3xl font-bold text-gray-800 mb-4">Payment Successful!</h1>
                        <p className="text-gray-600 text-center max-w-sm mb-8">
                            Thank you for your payment. Your transaction has been processed successfully. You will be redirected to the dashboard shortly.
                        </p>
                        <Button onClick={handleNavigate} className="bg-green-600 hover:bg-green-700">
                            Go to Dashboard Now
                        </Button>
                    </div>
                </Card>
            </div>
        </PageWrapper>
    );
};

export default PaymentSuccess;
